import { FireIcon, SparklesIcon } from '@heroicons/react/20/solid';
import { BTUsType } from 'data/types';
import { useEffect, useState } from 'react';
import { abbreviateNumber } from 'utils/helpers';

type BTUBubblesProps = {
  BTUs: BTUsType | BTUsType[];
  abbreviateNumbers?: boolean;
};

export default function BTUBubbles({
  BTUs,
  abbreviateNumbers = false
}: BTUBubblesProps) {
  const [totalBTUs, setTotalBTUs] = useState<BTUsType>({
    heating: 0,
    cooling: 0,
    latent: 0
  });

  useEffect(() => {
    if (Array.isArray(BTUs)) {
      let totalHeating = 0;
      let totalCooling = 0;
      let totalLatent = 0;
      BTUs.forEach((BTU) => {
        totalHeating += BTU.heating;
        totalCooling += BTU.cooling;
        totalLatent += BTU.latent ?? 0;
      });
      setTotalBTUs({
        heating: totalHeating,
        cooling: totalCooling,
        latent: totalLatent
      });
    } else {
      setTotalBTUs({
        heating: BTUs.heating,
        cooling: BTUs.cooling,
        latent: BTUs.latent ?? 0
      });
    }
  }, [BTUs]);

  const totalCoolingDisplay = totalBTUs.cooling + (totalBTUs.latent ?? 0);

  return (
    <div className='flex items-center gap-3'>
      <div className='flex items-center gap-[2px]'>
        <SparklesIcon className='h-5 w-5 text-sky-500' />
        <span className='text-sm font-semibold text-gray-900'>
          {abbreviateNumbers
            ? abbreviateNumber(Math.round(totalCoolingDisplay))
            : Math.round(totalCoolingDisplay).toLocaleString()}
        </span>
      </div>
      <div className='flex items-center gap-[2px]'>
        <FireIcon className='h-5 w-5 text-orange-500' />
        <span className='text-sm font-semibold text-gray-900'>
          {abbreviateNumbers
            ? abbreviateNumber(Math.round(totalBTUs.heating))
            : Math.round(totalBTUs.heating).toLocaleString()}
        </span>
      </div>
    </div>
  );
}
